import type { WorkflowStepStatus } from '@/api'

export type WorkflowStepIndicator = 'completed' | 'active' | 'pending'

export interface WorkflowStepTransitionState {
  isCompleted: boolean
  nextCompleted: boolean
  actionLabel: 'Mark as Complete' | 'Reopen Step'
  statusMessage: string
  indicator: WorkflowStepIndicator
}

interface WorkflowStepTransitionInput {
  stepId: string
  completedStepIds: ReadonlySet<string>
  currentStepId?: string
}

export const buildCompletedStepSet = (
  workflowSteps: WorkflowStepStatus[]
): Set<string> => new Set(workflowSteps.filter((step) => step.status === 'completed').map((step) => step.step_id))

export const getWorkflowStepTransitionState = ({
  stepId,
  completedStepIds,
  currentStepId,
}: WorkflowStepTransitionInput): WorkflowStepTransitionState => {
  const isCompleted = completedStepIds.has(stepId)

  return {
    isCompleted,
    nextCompleted: !isCompleted,
    actionLabel: isCompleted ? 'Reopen Step' : 'Mark as Complete',
    statusMessage: isCompleted
      ? 'Step completed and recorded.'
      : 'Mark this step as complete to advance.',
    indicator: isCompleted ? 'completed' : stepId === currentStepId ? 'active' : 'pending',
  }
}
